var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardRsvpClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06351 0.874252C3.14923 0.874252 1.5974 2.42608 1.5974 4.34037C1.5974 6.25465 3.14923 7.80648 5.06351 7.80648C6.97779 7.80648 8.52963 6.25465 8.52963 4.34037C8.52963 2.42608 6.97779 0.874252 5.06351 0.874252ZM0.827148 4.34037C0.827148 2.00069 2.72383 0.104004 5.06351 0.104004C7.40319 0.104004 9.29988 2.00069 9.29988 4.34037C9.29988 6.68005 7.40319 8.57673 5.06351 8.57673C2.72383 8.57673 0.827148 6.68005 0.827148 4.34037Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06383 1.64502C5.27653 1.64502 5.44896 1.81745 5.44896 2.03014V4.10287L6.77656 4.76667C6.96681 4.86179 7.04392 5.09312 6.9488 5.28337C6.85367 5.47361 6.62234 5.55072 6.4321 5.4556L4.8916 4.68535C4.76113 4.62012 4.67871 4.48676 4.67871 4.34089V2.03014C4.67871 1.81745 4.85114 1.64502 5.06383 1.64502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRsvpClockIcon);
export default __webpack_public_path__ + "static/media/dashboard-rsvp-clock-icon.030010c2a20793f53889a13ca87e43dd.svg";
export { ForwardRef as ReactComponent };